// ══════════════════════════════════════════════════════
//  promptBlocks/valuationBlock.js — AI prompt 估值块
//
//  返回空字符串 = 该项目无估值数据，prompt 应跳过此块
// ══════════════════════════════════════════════════════

import { extract } from '../extractors/valuation';
import { fmtUSD, fmtRatio } from '../extractors/_shared';

export function buildPromptBlock(project /* , a */) {
  const d = extract(project);
  if (!d) return '';

  const lines = [];
  lines.push('【估值 & 核心倍数（数据源: ' + d.source + '）】');
  if (d.mc != null)   lines.push(`Market Cap: ${fmtUSD(d.mc)}`);
  if (d.fdv != null)  lines.push(`FDV (全摊薄): ${fmtUSD(d.fdv)}`);
  if (d.feesAnn != null) lines.push(`30日年化手续费: ${fmtUSD(d.feesAnn)}`);
  if (d.revAnn != null)  lines.push(`30日年化收入: ${fmtUSD(d.revAnn)}`);
  if (d.mcRev != null)   lines.push(`MC/Rev (年化) = ${fmtRatio(d.mcRev)}  (<15x极便宜 · 15-30x合理 · 30-50x中性 · 50-100x偏高 · >100x过热)`);
  if (d.fdvRev != null)  lines.push(`FDMC/Rev (年化) = ${fmtRatio(d.fdvRev)}`);
  if (d.mcFees != null)  lines.push(`MC/Fees (年化) = ${fmtRatio(d.mcFees)}`);
  if (d.fdvFees != null) lines.push(`FDMC/Fees (年化) = ${fmtRatio(d.fdvFees)}`);

  return lines.join('\n');
}
